var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDollarSign = function SvgDollarSign(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#363840",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    clipPath: "url(#dollar-sign_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 .667v14.666M11.333 3.333h-5a2.333 2.333 0 0 0 0 4.667h3.334a2.333 2.333 0 0 1 0 4.667H4"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "dollar-sign_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: props.fill,
    d: "M0 0h16v16H0z"
  }))));
};
export default SvgDollarSign;